import { css } from "@emotion/react";

export const root = css`
  display: flex;
  align-items: center;
`;

export const logoutButton = css`
  border: 1px solid #dbeafe;
  background: #ffffff;
  color: #001740;
  padding: 10px 16px;
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    background: #f2f6ff;
  }
`;